import React, { useState, useEffect, useRef } from 'react';

const CountryFilter = ({ countries, activeCountry, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const allOptions = ['All', ...countries];
  const activeLabel = activeCountry === 'All' ? 'All Countries' : activeCountry;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    onChange(value);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative inline-block">
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2 rounded-full border px-5 py-2.5 text-sm font-medium transition-all duration-300 bg-teal-50 text-teal-900 border-teal-200 hover:border-teal-300 hover:text-teal-700 hover:bg-teal-100 focus:outline-none focus:ring-2 focus:ring-teal-200"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span>{activeLabel}</span>
        <svg
          className={`w-4 h-4 text-teal-500 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute z-50 mt-2 w-56 max-h-64 overflow-y-auto rounded-2xl border border-gray-100 bg-white shadow-xl ring-1 ring-black/5 py-1">
          {allOptions.map((option) => (
            <button
              key={option}
              onClick={() => handleSelect(option)}
              className={`w-full text-left px-4 py-2.5 text-sm transition-colors duration-150 ${
                activeCountry === option
                  ? 'bg-primary/5 text-primary font-semibold'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
              role="option"
              aria-selected={activeCountry === option}
            >
              <div className="flex items-center justify-between">
                <span>{option === 'All' ? 'All Countries' : option}</span>
                {activeCountry === option && (
                  <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountryFilter;
